import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { common } from '@/api/api_url';
import config from '@/config/index.js';
import { renderFormMixins } from '@/mixins/renderFormMixins';
export default {
  name: "certification",
  mixins: [renderFormMixins],
  data: function data() {
    return {
      countdown: null,
      submitLoading: false,
      refName: 'refName',
      currSelectImg: null,
      visible: false,
      spinShow: false,
      //上传图显示
      showImgIcon: {
        front_idcard: null,
        example_rearview: null,
        hand_idcard: null
      },
      //示例图地址
      imgDemo: {
        example_facetoup: null,
        back_idcard: null,
        hand_idcard: null
      },
      //提交数据
      formModel: {
        admin_real_name: null,
        admin_idcard_num: null,
        front_idcard: null,
        back_idcard: null,
        hand_idcard: null
      },
      formRules: {
        admin_real_name: [{
          required: true,
          message: this._vm.$t('auth.namenotice'),
          trigger: 'change'
        }],
        admin_idcard_num: [{
          required: true,
          message: this._vm.$t('auth.notNullCard'),
          trigger: 'change'
        }, {
          pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
          message: this._vm.$t('auth.noformatCard'),
          trigger: 'change'
        }],
        front_idcard: [{
          required: true,
          message: this._vm.$t('auth.frontCardNotice'),
          trigger: 'change'
        }],
        back_idcard: [{
          required: true,
          message: this._vm.$t('auth.backCardNotice'),
          trigger: 'change'
        }],
        hand_idcard: [{
          required: true,
          message: this._vm.$t('auth.handCardNotice'),
          trigger: 'change'
        }]
      },
      statusData: {
        authentication: 0,
        count_down: '',
        admin_real_name: '',
        real_audit_desc: ""
      }
    };
  },
  props: {
    edit: {},
    _vm: {},
    $store: {}
  },
  components: {},
  computed: {
    fileAction: function fileAction() {
      var result = '';

      if (process.env.NODE_ENV === 'development') {
        result = config.showImg.dev + "" + common.UploadFile;
      } else if (process.env.VUE_APP_BUILD === 'production') {
        result = config.showImg.pro + "" + common.UploadFile;
      } else {
        result = config.showImg.alp + "" + common.UploadFile;
      }

      return result;
    },
    //文件访问前缀
    getRoot: function getRoot() {
      var root = config.showImg.pro;

      if (process.env.NODE_ENV === 'development') {
        root = config.showImg.dev;
      } else if (process.env.VUE_APP_BUILD === 'production') {
        root = config.showImg.pro;
      } else {
        root = config.showImg.alp;
      }

      return root;
    },
    userInfoStore: function userInfoStore() {
      var data = this._vm.$store.state.user.userInfo;
      return data;
    }
  },
  methods: {
    formatBit: function formatBit(val) {
      val = +val;
      return val > 9 ? val : '0' + val;
    },
    // 秒转时分秒，求模很重要，数字的下舍入
    formatSeconds: function formatSeconds(time) {
      var min = Math.floor(time % 3600);
      return this.countdown = this.formatBit(Math.floor(time / 3600)) + ':' + this.formatBit(Math.floor(min / 60)) + ':' + this.formatBit(time % 60);
    },
    // 定时器
    minReturn: function minReturn(time) {
      var vm = this;
      var t = setInterval(function () {
        time--;
        vm.formatSeconds(time);

        if (time <= 0) {
          clearInterval(t);
        }
      }, 1000);
    },
    handleFormatError: function handleFormatError(file) {
      this.spinShow = false;
      this.$Notice.warning({
        title: 'The file format is incorrect',
        desc: 'File format of ' + file.name + ' is incorrect, please select jpg or png.'
      });
    },
    handleMaxSize: function handleMaxSize(file) {
      this.spinShow = false;
      this.$Notice.warning({
        title: 'Exceeding file size limit',
        desc: 'File  ' + file.name + ' is too large, no more than 2M.'
      });
    },
    handleBeforeUpload: function handleBeforeUpload() {
      this.spinShow = true;
      return true;
    },
    handleView: function handleView(name) {
      this.currSelectImg = name;
      this.visible = true;
    },
    handleRemove: function handleRemove(file) {
      this.$set(this.showImgIcon, file, null);

      if (file == 'hand_idcard') {
        this.$set(this.formModel, 'hand_idcard', null);
      } else if (file == 'back_idcard') {
        this.$set(this.formModel, 'back_idcard', null);
      } else if (file == 'front_idcard') {
        this.$set(this.formModel, 'front_idcard', null);
      }
    },
    handleSuccess: function handleSuccess(res, file) {
      this.spinShow = false;

      if (res.result === 0) {
        this.$set(this.showImgIcon, 'front_idcard', this.getRoot + "" + res.body);
        this.$set(this.formModel, 'front_idcard', res.body);
      } else {
        this.$set(this.showImgIcon, 'front_idcard', null);
        this.$set(this.formModel, 'front_idcard', null);
      }
    },
    handleSuccess2: function handleSuccess2(res, file) {
      this.spinShow = false;

      if (res.result === 0) {
        this.$set(this.showImgIcon, 'back_idcard', this.getRoot + "" + res.body);
        this.$set(this.formModel, 'back_idcard', res.body);
      } else {
        this.$set(this.showImgIcon, 'back_idcard', null);
        this.$set(this.formModel, 'back_idcard', null);
      }
    },
    handleSuccess3: function handleSuccess3(res, file) {
      this.spinShow = false;

      if (res.result === 0) {
        this.$set(this.showImgIcon, 'hand_idcard', this.getRoot + "" + res.body);
        this.$set(this.formModel, 'hand_idcard', res.body);
      } else {
        this.$set(this.showImgIcon, 'hand_idcard', null);
        this.$set(this.formModel, 'hand_idcard', null);
      }
    },

    /**
     * 提交实名认证
     */
    handleSubmit: function handleSubmit() {
      var _this = this;

      this.$refs[this.refName].validate(function (valid) {
        if (valid) {
          _this.spinShow = true;

          _this.$store.dispatch("handlereal_name_auth", _this.formModel).then(function (res) {
            _this.spinShow = false;

            if (res.result === 0) {
              _this.$Message.success(_this.$t('实名认证成功')); //更新get_user_info


              _this.$store.dispatch('getUserInfo');
            } else {
              _this.$Message.error(res.errorMsg);
            }
          });
        }
      });
    },
    init: function init() {
      var _this2 = this;

      this.spinShow = true;

      this._vm.$store.dispatch("product/handleproduct_edit", {
        product_id: this.productId
      }).then(function (res) {
        _this2.spinShow = false;

        if (res.result === 0) {
          var _res$body = res.body,
              name = _res$body.name,
              model_code = _res$body.model_code,
              desc = _res$body.desc,
              intf_n = _res$body.intf_n,
              pics = _res$body.pics;
          var intfType = [];

          for (var i in intf_n) {
            var list = intf_n[i];

            for (var j = 0; j < _this2.getCommunicaType.length; j++) {
              var item = _this2.getCommunicaType[j];

              if (list == item.value) {
                intfType.push(item.label);
                break;
              }
            }
          }

          var faceupto, rearview, reset;

          if (pics) {
            faceupto = pics.faceupto || null;
            rearview = pics.rearview || null;
            reset = pics.reset || null; //

            _this2.$set(_this2.showImgIcon, 'front_idcard', _this2.getRoot + "" + faceupto);

            _this2.$set(_this2.showImgIcon, 'back_idcard', _this2.getRoot + "" + rearview);

            _this2.$set(_this2.showImgIcon, 'hand_idcard', _this2.getRoot + "" + reset);
          }

          var obj = {
            name: name,
            model_code: model_code,
            intf_n: intfType.join(','),
            faceupto: faceupto,
            rearview: rearview,
            reset: reset,
            desc: desc
          };
          Object.assign(_this2.formModel, obj);
        } else {}
      });
    },
    //获取示例图
    initProductImg: function initProductImg() {
      var vm = this; //示例图

      this.$set(vm.imgDemo, "front_idcard", "".concat(vm.getRoot).concat(vm.userInfoStore.example_idcard_list.front_idcard));
      this.$set(vm.imgDemo, "back_idcard", "".concat(vm.getRoot).concat(vm.userInfoStore.example_idcard_list.back_idcard));
      this.$set(vm.imgDemo, "hand_idcard", "".concat(vm.getRoot).concat(vm.userInfoStore.example_idcard_list.hand_idcard)); //图片

      this.$set(vm.showImgIcon, "front_idcard", vm.userInfoStore.front_idcard ? "".concat(vm.getRoot).concat(vm.userInfoStore.front_idcard) : '');
      this.$set(vm.showImgIcon, "back_idcard", vm.userInfoStore.back_idcard ? "".concat(vm.getRoot).concat(vm.userInfoStore.back_idcard) : '');
      this.$set(vm.showImgIcon, "hand_idcard", vm.userInfoStore.hand_idcard ? "".concat(vm.getRoot).concat(vm.userInfoStore.hand_idcard) : '');
      this.$set(this.formModel, 'front_idcard', "".concat(vm.userInfoStore.front_idcard));
      this.$set(this.formModel, 'back_idcard', "".concat(vm.userInfoStore.back_idcard));
      this.$set(this.formModel, 'hand_idcard', "".concat(vm.userInfoStore.hand_idcard));
      this.$set(this.formModel, 'admin_real_name', "".concat(vm.userInfoStore.admin_real_name));
      this.$set(this.formModel, 'admin_idcard_num', "".concat(vm.userInfoStore.admin_idcard_num));
    },
    initStatus: function initStatus() {
      var _this3 = this;

      this.$store.dispatch("handlerealname_audit_count_downr", {}).then(function (res) {
        if (res.result === 0) {
          _this3.$set(_this3.statusData, 'authentication', res.body.authentication);

          _this3.$set(_this3.statusData, 'count_down', res.body.count_down);

          _this3.$set(_this3.statusData, 'admin_real_name', res.body.admin_real_name);

          _this3.$set(_this3.statusData, 'real_audit_desc', res.body.real_audit_desc);

          if (res.body.authentication === 1) {
            var count_down = res.body.count_down;

            if (count_down == '0') {
              _this3.countdown = '00:00:00';
            } else {
              _this3.minReturn(count_down);
            }
          }
        } else {}
      });
    },
    //重新实名认证
    resetAuthener: function resetAuthener() {
      this.$set(this.statusData, 'authentication', 0);
    }
  },
  mounted: function mounted() {},
  created: function created() {
    this.initStatus(); //获取 示例图

    this.initProductImg(); //回填实名认证信息
    //this.init();
  }
};